export enum Condition {
  Good = 'good',
  Fair = 'fair',
  Poor = 'poor',
  Disconnected = 'disconnected',
}



// WEBPACK FOOTER //
// ./src/app/dashboard/enums/condition.enum.ts